import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Input } from "components/bootstrap";
import { RowTitleButton } from "common/components";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
const InputWrapper = styled.div`
  cursor: pointer;

  .form-group {
    margin: 0;
    cursor: pointer;

    .radio {
      margin: 0;
      cursor: pointer;

      input[type='radio'] {
        cursor: pointer;
      }
    }
  }
`;
const SelectCell = ({
  eventProcedure
}) => {
  const selectedRows = useSelectedRows();
  const selectedRowsDispatch = useSelectedRowsDispatch();
  const isChecked = useMemo(
    () => !!selectedRows.find(
      (sProcedure) => eventProcedure.id === sProcedure.id
    ),
    [eventProcedure.id, selectedRows]
  );
  const onChange = useCallback(
    (e) => {
      if (e.target.checked) {
        selectedRowsDispatch({ type: "upsert", payload: [eventProcedure] });
      } else {
        selectedRowsDispatch({ type: "remove", payload: [eventProcedure] });
      }
    },
    [eventProcedure, selectedRowsDispatch]
  );
  return /* @__PURE__ */ React.createElement(InputWrapper, null, /* @__PURE__ */ React.createElement(Input, { type: "radio", checked: isChecked, onChange }));
};
const TitleCell = ({
  eventProcedure
}) => {
  const { t } = useTranslation("enterprise_security_events");
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(eventProcedure.id, "restFieldsExpandedSection");
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: toggleExtraSection }, (eventProcedure == null ? void 0 : eventProcedure.title) || t("title_cell.no_title"));
};
export const columnRenderers = {
  attributes: {
    select: {
      staticWidth: 40,
      renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(SelectCell, { eventProcedure })
    },
    title: {
      renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(TitleCell, { eventProcedure })
    }
  }
};
